import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getDateRangeValue } from '../../../packages/JsonQuery';

export const selectDates = createSelector(selectJsonQuery, jsonQuery => getDateRangeValue('dates')(jsonQuery));
